if (!customElements.get('paderpets-subscription-picker')) {
  customElements.define(
    'paderpets-subscription-picker',
    class PaderPetsSubscriptionPicker extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form[action*="/cart/add"]');
        this.variantInput =
          this.form?.querySelector('[name="id"]');

        this.planInput =
          this.querySelector('[data-selling-plan-input]');

        this.planSelect =
          this.querySelector('[data-selling-plan-select]');

        this.details =
          this.querySelector('[data-subscription-details]');

        this.oncePrice =
          this.querySelector('[data-once-price]');

        this.subscriptionPrice =
          this.querySelector('[data-subscription-price]');

        this.saving =
          this.querySelector('[data-subscription-saving]');

        this.radios = Array.from(
          this.querySelectorAll('input[type="radio"]')
        );

        this.subscriptionRadio =
          this.radios.find(
            (radio) => radio.value === 'subscription'
          );

        this.oncePrices = this.readOncePrices();
        this.allocations = this.readAllocations();

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => {
            this.updatePurchaseOption();
          });
        });

        this.planSelect?.addEventListener('change', () => {
          this.updatePlan();
        });

        this.variantInput?.addEventListener('change', () => {
          this.updateVariant();
        });

        this.updateVariant();
      }

      readOncePrices() {
        try {
          return JSON.parse(
            this.querySelector('[data-once-prices]')
              ?.textContent || '{}'
          );
        } catch (error) {
          console.error(
            'PaderPets: Einmalkaufpreise konnten nicht gelesen werden.',
            error
          );

          return {};
        }
      }

      readAllocations() {
        try {
          return JSON.parse(
            this.querySelector('[data-selling-plan-allocations]')
              ?.textContent || '{}'
          );
        } catch (error) {
          console.error(
            'PaderPets: Selling Plans konnten nicht gelesen werden.',
            error
          );

          return {};
        }
      }

      get currentOncePrice() {
        return (
          this.oncePrices[
            String(this.variantInput?.value || '')
          ] || {}
        );
      }

      get currentAllocations() {
        return (
          this.allocations[
            String(this.variantInput?.value || '')
          ] || {}
        );
      }

      updateVariant() {
        this.updateOncePrice();

        const allocations = this.currentAllocations;
        const availablePlanIds = Object.keys(allocations);

        Array.from(
          this.planSelect?.options || []
        ).forEach((option) => {
          option.disabled =
            !availablePlanIds.includes(option.value);
        });

        const selectedStillAvailable =
          availablePlanIds.includes(
            this.planSelect?.value
          );

        if (
          !selectedStillAvailable &&
          this.planSelect
        ) {
          this.planSelect.value =
            availablePlanIds[0] || '';
        }

        if (this.subscriptionRadio) {
          this.subscriptionRadio.disabled =
            availablePlanIds.length === 0;
        }

        if (
          availablePlanIds.length === 0 &&
          this.subscriptionRadio?.checked
        ) {
          const onceRadio =
            this.radios.find(
              (radio) => radio.value === 'once'
            );

          if (onceRadio) {
            onceRadio.checked = true;
          }
        }

        this.updatePurchaseOption();
      }

      updateOncePrice() {
        if (!this.oncePrice) {
          return;
        }

        const priceData = this.currentOncePrice;

        const regularPrice =
          Number(priceData.regularPrice || 0);

        const offerPrice =
          Number(priceData.offerPrice || regularPrice);

        const percent =
          Number(priceData.percent || 0);

        this.oncePrice.textContent = '';

        if (
          percent > 0 &&
          offerPrice > 0 &&
          regularPrice > offerPrice
        ) {
          const regularElement =
            document.createElement('s');

          regularElement.className =
            'paderpets-subscription__once-regular';

          regularElement.textContent =
            this.formatMoney(regularPrice);

          const offerElement =
            document.createElement('strong');

          offerElement.className =
            'paderpets-subscription__once-offer';

          offerElement.textContent =
            this.formatMoney(offerPrice);

          const noteElement =
            document.createElement('small');

          noteElement.className =
            'paderpets-subscription__once-note';

          noteElement.textContent =
            `Aktionspreis · −${Math.round(percent)} %`;

          this.oncePrice.append(
            regularElement,
            document.createTextNode(' '),
            offerElement,
            document.createElement('br'),
            noteElement
          );

          return;
        }

        this.oncePrice.textContent =
          this.formatMoney(regularPrice);
      }

      updatePurchaseOption() {
        const subscriptionSelected =
          this.subscriptionRadio?.checked &&
          !this.subscriptionRadio.disabled;

        this.radios.forEach((radio) => {
          radio
            .closest(
              '.paderpets-subscription__choice'
            )
            ?.classList.toggle(
              'is-selected',
              radio.checked
            );
        });

        if (this.details) {
          this.details.hidden =
            !subscriptionSelected;
        }

        if (this.planSelect) {
          this.planSelect.disabled =
            !subscriptionSelected;
        }

        if (this.planInput) {
          this.planInput.disabled =
            !subscriptionSelected;
        }

        if (subscriptionSelected) {
          this.updatePlan();
        } else if (this.planInput) {
          this.planInput.value = '';
        }

        this.updateButtonLabel(
          subscriptionSelected
        );
      }

      updatePlan() {
        const allocation =
          this.currentAllocations[
            this.planSelect?.value
          ];

        if (!allocation) {
          return;
        }

        this.planInput.value =
          this.planSelect.value;

        if (this.subscriptionPrice) {
          this.subscriptionPrice.textContent =
            `${this.formatMoney(allocation.price)} je Lieferung`;
        }

        const compareAtPrice =
          Number(allocation.compareAtPrice || 0);

        const price =
          Number(allocation.price || 0);

        const percent =
          compareAtPrice > price
            ? Math.round(
                (1 - price / compareAtPrice) * 100
              )
            : 0;

        const amount =
          Math.max(compareAtPrice - price, 0);

        if (this.saving) {
          this.saving.textContent =
            percent > 0
              ? `Du sparst ${percent} % (${this.formatMoney(amount)}) je Lieferung.`
              : 'Bequem regelmäßig liefern lassen.';
        }
      }

      updateButtonLabel(
        subscriptionSelected
      ) {
        const label =
          this.form?.querySelector(
            '.product-form__submit > span:first-child'
          );

        if (
          !label ||
          this.form?.querySelector(
            '.product-form__submit[disabled]'
          )
        ) {
          return;
        }

        label.textContent =
          subscriptionSelected
            ? 'Im Abo hinzufügen'
            : window.variantStrings?.addToCart ||
              'In den Warenkorb';
      }

      formatMoney(cents) {
        const locale =
          document.documentElement.lang ||
          'de-DE';

        try {
          return new Intl.NumberFormat(
            locale,
            {
              style: 'currency',
              currency:
                this.dataset.currency || 'EUR'
            }
          ).format(
            Number(cents || 0) / 100
          );

        } catch (error) {
          return `${(
            Number(cents || 0) / 100
          )
            .toFixed(2)
            .replace('.', ',')} €`;
        }
      }
    }
  );
}